import { UserOutlined } from "@ant-design/icons";
import { Avatar, Tooltip } from "antd";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import NameAndValue from "../Items/NameAndValue";

type Props = {};

const Appointment = ({
  serv,
  teamMember,
  start_time,
  finish_time,
  client,
  status,
  reservation,
}: any) => {
  let statusText = "";
  let statusColor = "";
  const intl = useIntl();
  var dateFormatter = "23/02/2017";

  switch (reservation?.status) {
    case "created":
      statusText = intl.formatMessage({ id: "statusCreated" });
      statusColor = "#2E74B5";
      break;
    case "started":
      statusText = intl.formatMessage({ id: "statusStarted" });
      statusColor = "#CF953D";
      break;
    case "completed":
      statusText = intl.formatMessage({ id: "statusCompleted" });
      statusColor = "#479821";
      break;
    case "canceled":
      statusText = intl.formatMessage({ id: "statusCanceled" });
      statusColor = "#C43535";
      break;
    case "pending":
      statusText = intl.formatMessage({ id: "statusPending" });
      statusColor = "#2E74B5";
      break;
    default:
      statusText = ""; // Consider handling an undefined status
      statusColor = ""; // Default or error color
      break;
  }
  const navigate = useNavigate();
  console.log(reservation);

  return (
    <div className="p-4 text-xs max-md:text-[10px] hover:bg-slate-50 py-2 border-color-gray border-solid border-[1px] rounded-xl  flex items-center justify-between w-full">
      <div className="flex items-center gap-1 text-color-gray ">
        <div className="flex items-center gap-1 min-w-[50px]">
          <span className="min-w-[88px] whitespace-nowrap max-lg:text-xs">
            {reservation?.appointment_services.length +
              reservation?.appointment_packages.length >
            1
              ? intl.formatMessage({
                  id: "teamMembers",
                })
              : intl.formatMessage({
                  id: "TeamMember",
                })}
          </span>
          <div className="w-[50px]">
            <Avatar.Group
              size={24}
              maxCount={2}
              maxStyle={{
                color: "#00086d",
                // height: "24px",

                backgroundColor: "#fff",
              }}
            >
              {[
                ...reservation?.appointment_services,
                ...reservation?.appointment_packages,
              ]?.map((teamMember: any, index: any) => (
                <Tooltip
                  title={teamMember?.team_member?.name}
                  placement="top"
                  key={index}
                >
                  <Avatar
                    size={24}
                    style={{
                      // height: "24px",
                      // width: "24px",
                      backgroundColor: "#00086d",
                    }}
                    src={teamMember?.team_member?.media}
                    icon={<UserOutlined />}
                    alt="Ellipse"
                  />
                </Tooltip>
              ))}
            </Avatar.Group>
          </div>
        </div>
        <div className="flex max-sm:flex-col items-center text-xs max-md:text-[10px]">
          <div className="flex items-center w-full gap-2 px-2 py-1 text-center">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-1"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 0.837209C3.15026 0.837209 0.837209 3.15026 0.837209 6C0.837209 8.84974 3.15026 11.1628 6 11.1628C8.84974 11.1628 11.1628 8.84974 11.1628 6C11.1628 3.15026 8.84974 0.837209 6 0.837209ZM0 6C0 2.68788 2.68788 0 6 0C9.31212 0 12 2.68788 12 6C12 9.31212 9.31212 12 6 12C2.68788 12 0 9.31212 0 6Z"
                fill="#9999A7"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.79165 3.0752C6.02284 3.0752 6.21026 3.26261 6.21026 3.4938V5.78217C6.21026 5.86787 6.24298 5.99209 6.31575 6.11968C6.38853 6.24731 6.47872 6.33861 6.55203 6.38205L6.55315 6.38271L8.28338 7.41527C8.4819 7.53374 8.5468 7.79072 8.42832 7.98925C8.30985 8.18777 8.05287 8.25267 7.85434 8.13419L6.12522 7.10229L6.12464 7.10195C5.89683 6.96677 5.71374 6.75406 5.58849 6.53443C5.46311 6.31458 5.37305 6.0481 5.37305 5.78217V3.4938C5.37305 3.26261 5.56046 3.0752 5.79165 3.0752Z"
                fill="#9999A7"
              />
            </svg>
            <span className="flex items-center text-center text-black">
              {/* {reservation?.start_time} - {reservation?.finish_time} */}
              {dayjs(
                dateFormatter + " " + reservation?.start_time,
                "DD/MM/YYYY HH:mm:ss"
              ).format("HH:mm")}
              -
              {dayjs(
                dateFormatter + " " + reservation?.finish_time,
                "DD/MM/YYYY HH:mm:ss"
              ).format("HH:mm")}
              {/* <span className="text-[8px] text-color-gray mt-1 mr-[2px]">
                  ص
                </span> */}
            </span>
          </div>
          <NameAndValue
            name={
              <svg
                width="11"
                height="12"
                viewBox="0 0 11 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.11523 2.74284C3.11523 1.228 4.34324 0 5.85807 0C7.37291 0 8.60091 1.228 8.60091 2.74284C8.60091 4.25767 7.37291 5.48568 5.85807 5.48568C4.34324 5.48568 3.11523 4.25767 3.11523 2.74284ZM5.85807 1C5.10067 1 4 1.98544 4 2.74284C4 3.50024 5.10067 4.61482 5.85807 4.61482C6.61547 4.61482 7.74296 3.50024 7.74296 2.74284C7.74296 1.98544 6.61547 1 5.85807 1Z"
                  fill="#9999A7"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.14339 6.5144C2.24987 6.5144 0.714844 8.04943 0.714844 9.94295V11.3144C0.714844 11.6931 1.02184 12.0001 1.40055 12.0001H10.3148C10.6935 12.0001 11.0005 11.6931 11.0005 11.3144V9.94295C11.0005 8.04943 9.46549 6.5144 7.57194 6.5144H4.14339ZM1.75996 9.94295C1.75996 8.80683 3.00727 7.5 4.14339 7.5H7.57194C8.70806 7.5 10.0883 8.80683 10.0883 9.94295V11H1.75996V9.94295Z"
                  fill="#9999A7"
                />
              </svg>
            }
            value={
              reservation?.appointmentable?.name ||
              reservation?.appointmentable?.first_name
            }
          />
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-xs max-md:text-[10px] font-semibold">
          <span style={{ color: statusColor }}>{statusText}</span>
        </div>
        <div
          onClick={() => navigate(`/calendar?id=${reservation.id}`)}
          className="cursor-pointer"
        >
          <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5408 0.186485C12.4214 0.0670807 12.2595 -3.77439e-09 12.0906 0C11.9218 3.77439e-09 11.7598 0.0670807 11.6404 0.186485C11.521 0.305889 11.4539 0.467837 11.4539 0.6367C11.4539 0.805563 11.521 0.96751 11.6404 1.08691L13.0992 2.54574H8.59072C7.66249 2.54574 6.77228 2.91448 6.11592 3.57084C5.45956 4.22719 5.09082 5.11741 5.09082 6.04564C5.09082 6.97387 5.45956 7.86409 6.11592 8.52045C6.77228 9.17681 7.66249 9.54554 8.59072 9.54554C8.75949 9.54554 8.92135 9.4785 9.04069 9.35916C9.16003 9.23982 9.22707 9.07797 9.22707 8.9092C9.22707 8.74043 9.16003 8.57857 9.04069 8.45923C8.92135 8.3399 8.75949 8.27285 8.59072 8.27285C8.00003 8.27285 7.43353 8.0382 7.01585 7.62052C6.59816 7.20283 6.36351 6.63633 6.36351 6.04564C6.36351 5.45495 6.59816 4.88845 7.01585 4.47076C7.43353 4.05308 8.00003 3.81843 8.59072 3.81843H13.0992L11.6404 5.27725C11.521 5.39666 11.4539 5.5586 11.4539 5.72747C11.4539 5.89633 11.521 6.05828 11.6404 6.17768C11.7598 6.29709 11.9218 6.36417 12.0906 6.36417C12.2595 6.36417 12.4214 6.29709 12.5408 6.17768L15.0862 3.6323C15.1454 3.5732 15.1923 3.50302 15.2243 3.42577C15.2564 3.34852 15.2729 3.26571 15.2729 3.18208C15.2729 3.09846 15.2564 3.01565 15.2243 2.9384C15.1923 2.86115 15.1454 2.79097 15.0862 2.73187L12.5408 0.186485Z"
              fill="#9999A7"
            />
            <path
              d="M0 4.45469V12.0908C0 12.5972 0.20113 13.0827 0.559144 13.4407C0.917158 13.7988 1.40273 13.9999 1.90904 13.9999H12.0906C12.5969 13.9999 13.0825 13.7988 13.4405 13.4407C13.7985 13.0827 13.9996 12.5972 13.9996 12.0908V8.27277C13.9996 8.104 13.9326 7.94214 13.8132 7.8228C13.6939 7.70347 13.532 7.63642 13.3633 7.63642C13.1945 7.63642 13.0326 7.70347 12.9133 7.8228C12.794 7.94214 12.7269 8.104 12.7269 8.27277V12.0908C12.7269 12.2596 12.6599 12.4215 12.5405 12.5408C12.4212 12.6601 12.2593 12.7272 12.0906 12.7272H1.90904C1.74027 12.7272 1.57841 12.6601 1.45907 12.5408C1.33974 12.4215 1.27269 12.2596 1.27269 12.0908V4.45469C1.27269 4.28592 1.33974 4.12407 1.45907 4.00473C1.57841 3.88539 1.74027 3.81835 1.90904 3.81835H3.81808C3.98685 3.81835 4.1487 3.7513 4.26804 3.63196C4.38738 3.51263 4.45442 3.35077 4.45442 3.182C4.45442 3.01323 4.38738 2.85137 4.26804 2.73204C4.1487 2.6127 3.98685 2.54565 3.81808 2.54565H1.90904C1.40273 2.54565 0.917158 2.74678 0.559144 3.1048C0.20113 3.46281 0 3.94838 0 4.45469Z"
              fill="#9999A7"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Appointment;
